import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EcoImg from 'eco-design/base/eco-img';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const IS_EU = ['eu', 'uk', 'de', 'es', 'fr', 'it'].includes(locale);
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_ROW = ['au', 'mx', 'br', 'kr', 'ph', 'za', 'sa'].includes(locale);

    return (
        <div className={`${css.animationM} animationM GtmModuleData-section`} data-section-id={css.animationM} data-section-title={t('delta2.aniM_title')}>
            <div className="static-box">
                {!['au'].includes(locale) && (
                    <div className="msg-box1">
                        <EFPic name={['animM1.webp', 'animM1.jpg']} />
                        <div className="text-wrapper">
                            <div className="msg1">{t('delta2.aniM_msg1')}</div>
                            <div className="msg2">{t('delta2.aniM_msg2')}</div>
                        </div>
                    </div>
                )}
                {['au'].includes(locale) && (
                    <div className="msg-box1">
                        <EFPic name={['good_design.png', 'good_design.png']} />
                        <div className="text-wrapper good-design">
                            <div className="title">{t('delta2.aniG_msg7')}</div>
                            <div className="desc">{t('delta2.good_design')}</div>
                        </div>
                    </div>
                )}
                <div className="msg-box2">
                    <div className="msg-left">
                        <EFPic name={['animM3.webp', 'animM3.jpg']} />
                        <div className="text-wrapper">
                            <div className="msg1">{t('delta2.aniM_msg3')}</div>
                            <div className="msg2">{t('delta2.aniM_msg4')}</div>
                            <div className="msg3">
                                <div className="number">{t('delta2.aniM_num1')}</div>
                                <div className="text">{t('delta2.aniM_msg5')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="msg-right">
                        <EFPic name={['animM4.webp', 'animM4.jpg']} />
                        <div className="text-wrapper">
                            <div className="msg1">{t('delta2.aniM_msg6')}</div>
                            <div className="msg2">{t('delta2.aniM_msg7')}</div>
                        </div>
                    </div>
                </div>
                <div className="msg-box3">
                    {IS_EU || IS_NA || IS_ROW ? (
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1755481187230/delta2_eu.jpg" />
                    ) : (
                        <EFPic name={['animM2.webp', 'animM2.jpg']} />
                    )}
                    <div className="text-wrapper">
                        <div className="msg1">{t('delta2.aniM_msg8')}</div>
                        <p className="msg2">{t('delta2.aniM_msg10')}</p>
                    </div>
                </div>
                <div className="msg-box4">{t('delta2.aniM_msg9')}</div>
            </div>
        </div>
    );
}
